import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '@neotech-solutions-org/neofusion-fe-shared';
import { useNavigate } from 'react-router';
import { Menu, MenuItem, MenuList } from '@mui/material';
import { StyleObj } from '../../@types';
import usePermissions from '../../hooks/usePermissions';

const styles: StyleObj = {
  container: {
    minWidth: 120,
  },
  menuList: {
    '& .MuiList-root': {
      p: 0,
    },
    '& .MuiMenuItem-root': {
      px: 1.25,
      fontWeight: 600,
      ':hover': {
        backgroundColor: 'background.lighter',
      },
    },
  },
};

const AccountIcon = () => {
  const [openAccountMenu, setOpenAccountMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const { handleLogout } = useAuth();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const canAccessWallet = hasPermission('accessWallet');

  const handleAccountMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpenAccountMenu(true);
  };

  const handleAccountMenuClose = () => {
    setAnchorEl(null);
    setOpenAccountMenu(false);
  };

  const handleClearSession = () => {
    sessionStorage.clear();
  };

  const handleLogoutClick = () => {
    handleLogout();
    handleAccountMenuClose();
    handleClearSession();
  };

  return (
    <>
      <IconButton
        size='large'
        aria-controls={openAccountMenu ? 'fade-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={openAccountMenu ? 'true' : undefined}
        edge='end'
        color='inherit'
        aria-label='menu'
        onClick={handleAccountMenuOpen}
      >
        <AccountCircle color='primary' />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openAccountMenu}
        onClose={handleAccountMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: -10, horizontal: 'center' }}
        elevation={3}
        slotProps={{
          paper: {
            sx: styles.container,
          },

          list: {
            disablePadding: true,
            sx: styles.menuList,
          },
        }}
      >
        <MenuList>
          {canAccessWallet && <MenuItem onClick={() => navigate('/my-wallet')}>Wallet</MenuItem>}
          <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};

export default AccountIcon;
